import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class EditionAPI {
    constructor() {
        this.baseUrl = new URL("edition/", apiDataManagerBaseURL);
    }

    get(argument, provider = '') {
        const url = new URL(argument, this.baseUrl);

        return API.authenticatedRequest({
            url: '' === provider ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    getSync(argument, provider = '') {
        const url = new URL(argument, this.baseUrl);

        return API.authenticatedRequestSync({
            url: '' === provider ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    getModifications(month, year, provider = '') {
        const url = new URL(`all/${month}/${year}`, this.baseUrl);

        return API.authenticatedRequest({
            url: '' === provider ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    getImportable(argument, provider = '') {
        const url = new URL(`${argument}/importable`, this.baseUrl);

        return API.authenticatedRequest({
            url: '' === provider ? url : `${url}?providerId=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    save(argument, edition) {
        const url = new URL(argument, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(edition)
        });
    }
    
    copy(argument, edition) {
        const url = new URL(`${argument}/copy`, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(edition)
        });
    }

    update(argument, id, edition) {
        const url = new URL(`${argument}/${id}`, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(edition)
        });
    }

    publish(argument, id, edition) {
        const url = new URL(`${argument}/publish/${id}`, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(edition)
        });
    }

    archive(argument, id, edition) {
        const url = new URL(`${argument}/archive/${id}`, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(edition)
        });
    }

    delete(argument, id) {
        const url = new URL(`${argument}/${id}`, this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/EditionAPI.js